export const roundToNearestEvenNumber = (num: number) =>
  2 * Math.round(num / 2);
